module.exports = __webpack_public_path__ + "portal/assets/img/AppAuthy.aee1337b.png";